import { StyledButton } from '@components/core';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Link, useRouter } from '@tanstack/react-router';

export default function NotFound() {
  const router = useRouter();
  return (
    <Box display='flex' justifyContent='center' bgcolor='common.white' p={4}>
      <Box maxWidth='27rem'>
        <Typography
          variant='h1'
          fontFamily={(theme) => theme.typography.fontFamily.header}
          color='secondary'
          mr={4}
        >
          Oops!
        </Typography>
        <Typography
          variant='h4'
          fontFamily='LabGrotesque'
          color='secondary'
          fontWeight='400'
        >
          The page you are looking for cannot be found
        </Typography>
        <Typography
          variant='h6'
          fontFamily='LabGrotesque'
          mt={4}
          lineHeight={0.75}
          color='secondary'
        >
          Possible reasons:
        </Typography>
        <ul>
          <li>
            <Typography
              variant='caption'
              fontFamily='LabGrotesque'
              color='secondary'
            >
              You may have mistyped the address
            </Typography>
          </li>
          <li>
            <Typography
              variant='caption'
              fontFamily='LabGrotesque'
              color='secondary'
            >
              The page may have moved
            </Typography>
          </li>
        </ul>
        <Divider flexItem sx={{ my: '1rem' }} />
        {
          <StyledButton
            component={Link}
            color='primary'
            variant='contained'
            fullWidth
            sx={{ margin: 'auto' }}
            onClick={() => router.history.back()}
          >
            Go Back
          </StyledButton>
        }
      </Box>
    </Box>
  );
}
